var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
      'ez-option',
      { 'ez-option--selected': _vm.selected },
      { 'ez-option--disabled': _vm.disabled }
    ],on:{"click":function($event){!_vm.disabled && _vm.select(_vm.option)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }